var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.707 13.707l11-11a1 1 0 00-1.414-1.414L11 11.586 7.707 8.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2a1 1 0 00-1 1v18a1 1 0 001 1h18a1 1 0 001-1V11a1 1 0 10-2 0v9H3V4h12a1 1 0 100-2H2z"
  })));
}
export default SvgCheckList;